import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { useMemo } from 'react';
import { ethers } from 'ethers';
import '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api';
import '../../../../config/ApiEndpoint.js';
import '../../../../shared/logger.js';
import '../../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/rpc-providers';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import 'react-dom';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../components/IconButton/IconButton.js';
import '../../../../components/Alert/Alert.js';
import '@dynamic-labs/wallet-book';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import { usePromise } from '../../../../utils/hooks/usePromise/usePromise.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { useTransactionEstimatedGas } from '../../../../utils/hooks/useTransactionEstimatedGas/useTransactionEstimatedGas.js';

const useTransactionData = ({ provider, transaction, }) => {
    const { data: transactionValue, isLoading: isEffectiveValueLoading } = usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
        const val = yield transaction.value;
        return val ? ethers.BigNumber.from(val) : undefined;
    }));
    const { data: estimatedGas, isLoading: isEstimatedGasLoading } = useTransactionEstimatedGas(provider, transaction);
    const { data: providerGasPrice, isLoading: isProviderGasPrice } = usePromise(() => provider.getGasPrice(), []);
    const { data: transactionGasPrice, isLoading: isTransactionGasPriceLoading } = usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
        const gasPrice = yield transaction.gasPrice;
        return gasPrice ? ethers.BigNumber.from(gasPrice) : undefined;
    }), [transaction.gasPrice]);
    const isGasPriceLoading = isEstimatedGasLoading || isProviderGasPrice || isTransactionGasPriceLoading;
    const isGasLoading = isProviderGasPrice || isTransactionGasPriceLoading;
    const transactionGas = useMemo(() => transactionGasPrice && estimatedGas
        ? ethers.BigNumber.from(transactionGasPrice).mul(estimatedGas)
        : undefined, [estimatedGas, transactionGasPrice]);
    const gasEstimate = useMemo(() => !transactionGasPrice && providerGasPrice && estimatedGas
        ? ethers.BigNumber.from(providerGasPrice).mul(estimatedGas)
        : undefined, [transactionGasPrice, estimatedGas, providerGasPrice]);
    const { data: transactionToAddress, isLoading: isTransactionToAddressLoading, } = usePromise(() => transaction.to);
    const { data: transactionFromAddress, isLoading: isTransactionFromAddressLoading, } = usePromise(() => transaction.from);
    const total = useMemo(() => {
        const transactionGasFee = transactionGas || gasEstimate;
        if (transactionGasFee !== undefined && transactionValue !== undefined) {
            return transactionGasFee.add(transactionValue);
        }
        return transactionValue || transactionGasFee;
    }, [gasEstimate, transactionGas, transactionValue]);
    const isLoading = useMemo(() => isEffectiveValueLoading ||
        isGasPriceLoading ||
        isTransactionToAddressLoading ||
        isTransactionFromAddressLoading, [
        isEffectiveValueLoading,
        isGasPriceLoading,
        isTransactionToAddressLoading,
        isTransactionFromAddressLoading,
    ]);
    return {
        gasEstimate,
        isEffectiveValueLoading,
        isGasLoading,
        isGasPriceLoading,
        isLoading,
        isTransactionFromAddressLoading,
        isTransactionGasPriceLoading,
        isTransactionToAddressLoading,
        total,
        transactionFromAddress,
        transactionGas,
        transactionGasPrice,
        transactionToAddress,
        transactionValue,
    };
};

export { useTransactionData };
